import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

const yddvizApp = {
  onMount: (name, element/*, yleVisualisation*/) => {
    if (name !== '2020-01-4g') return;
    if (!element.querySelector('#app-2020-01-4g')) return;

    // parameters passed from the SYND shortcode can be accessed like this
    /*
    let someParameter = null;
    if (yleVisualisation) {
      const parameters = yleVisualisation.getParameters();
      if (parameters && parameters.someParameter) {
        someParameter = parameters.someParameter;
      }
    }
    */

    new Vue({
      render: h => h(App, {
        props: {
          // someParameter: someParameter,
        }
      })
    }).$mount(`#app-${name}`)
  }
};

window.yleVisualisationEmbeds = window.yleVisualisationEmbeds || {};
window.yleVisualisationEmbeds['2020-01-4g'] = yddvizApp;
